<template>
  <dy-dialog
    v-model="visible"
    width="70%"
    title="选择客户"
    confirm-title="确定"
    :show-confirm="multiple ? !!selectRows.length : !!selectRow"
    @onConfirm="handleSelected"
    @onClose="handleClose"
  >
    <dy-main-container class="select-asset-dialog" hide-top-menu hide-left-aside>
      <template #right>
        <avue-crud
          ref="crud"
          :page.sync="page"
          :search.sync="searchForm"
          :data="tableList"
          :table-loading="tableLoading"
          :option="crudOption"
          @on-load="getList"
          @search-change="searchChange"
          @row-click="rowClick"
          @selection-change="selectionChange"
        >
          <template slot="radio" slot-scope="{row}">
            <el-radio v-model="selectRowIndex" :label="row.$index">&nbsp;</el-radio>
          </template>
        </avue-crud>
      </template>
    </dy-main-container>
  </dy-dialog>
</template>

<script>
import { getAllCustomerTableOption } from '@/const/crud/baseData/customer/householder'
import {
  getAllCustomerList
} from '@/api/v3/assets/customer/householder'
import store from '@/store'
import DyDialog from '@/components/DYDialog/index.vue'

export default {
  name: 'DySelectCustomerDialog',
  components: { DyDialog },
  data() {
    return {
      visible: false,
      assetType: 0,
      orgInfo: undefined,
      selectRow: undefined,
      selectRows: [],
      selectRowIndex: undefined,
      multiple: false,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      dividerOption: {
        leftAsideWidth: 225,
        leftAsideMinWidth: 200
      },
      searchForm: {},
      crudOption: undefined,
      tableList: undefined,
      tableLoading: false,
      tableColumns: [
        {
          label: '名称',
          prop: 'name',
          width: '70',
          mainColumn: true
        }
      ]
    }
  },
  computed: {
    project() {
      return store.getters.project
    }
  },
  methods: {
    open(params) {
      const { searchParams, resolve, cancel, multiple } = params || {}
      this.resolve = resolve
      this.cancel = cancel
      this.multiple = !!multiple
      this.selectRow = undefined
      this.selectRows = []
      this.selectRowIndex = undefined
      const crudOption = getAllCustomerTableOption()
      crudOption.height = 380
      crudOption.menu = false
      crudOption.index = false
      crudOption.searchMenuSpan = 12
      crudOption.selection = this.multiple
      if (!this.multiple) {
        crudOption.column.unshift({
          prop: 'radio',
          width: 60
        })
      }
      crudOption.column.forEach(item => {
        if (!['name', 'mobile'].includes(item.prop)) {
          item.search = false
        }
      })
      this.crudOption = crudOption
      this.visible = true
      Object.assign(this.searchForm, searchParams)
      this.getList()
    },
    searchChange(form, done) {
      this.getList()
      done()
    },
    async getList() {
      this.tableLoading = true
      const form = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        projectCode: this.project.code
      }
      const res = await getAllCustomerList(form)
      this.tableList = res.data.records.map(item => {
        item.houseName = (item.houseList || []).map(i => i.houseName).join('、')
        return item
      })
      this.page.total = Number(res.data.total)
      this.tableLoading = false
    },
    handleSelected() {
      this.visible = false
      const result = this.multiple ? this.selectRows : this.selectRow
      this.$emit('confirm', result)
      this.resolve && this.resolve(result)
    },
    handleClose() {
      this.selectRow = undefined
      this.selectRows = []
      this.selectRowIndex = undefined
      this.cancel && this.cancel()
    },
    rowClick(row) {
      if (this.multiple) return
      this.selectRow = row
      this.selectRowIndex = row.$index
    },
    selectionChange(rows) {
      this.selectRows = rows || []
    }
  }
}
</script>

<style scoped lang="scss">
.select-asset-dialog {
  height: 515px;
  overflow: hidden;
}

::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
